import React from "react";
import { useLang } from "../i18n/LanguageContext";

export default function Privacy() {
  const { t } = useLang();
  const sections = [
    { key: "intro", title: "privacy.introTitle", text: "privacy.introText" },
    { key: "use", title: "privacy.useTitle", text: "privacy.useText" },
    { key: "rights", title: "privacy.rightsTitle", text: "privacy.rightsText" },
    { key: "retention", title: "privacy.retentionTitle", text: "privacy.retentionText" },
  ];
  return (
    <div>
      <section className="border-b border-border-light">
        <div className="container-notary py-20 md:py-24">
          <div className="overline mb-4">{t("privacy.eyebrow")}</div>
          <h1 className="text-4xl md:text-5xl font-serif text-charcoal">{t("privacy.title")}</h1>
          <span className="divider-gold my-6 block" />
        </div>
      </section>
      <section className="container-notary py-16 max-w-3xl">
        <div className="space-y-10">
          {sections.map((s) => (
            <div key={s.key} data-testid={`privacy-${s.key}`}>
              <h2 className="font-serif text-2xl text-charcoal mb-3">{t(s.title)}</h2>
              <p className="text-charcoal-muted leading-relaxed">{t(s.text)}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
